import React from "react";
import { Heading, HeadingProps } from "@/shared/components/ui/Heading";

//Icons
import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface TableRowProps {
    title: string;
    description?: string;
    headingLevel?: HeadingProps["level"];
    badge?: React.ReactNode;
}

const TableRow: React.FC<TableRowProps> = ({ title, description, headingLevel = "h3", badge }) => {
    return (
        <div className="flex gap-2 rounded px-2 py-1 text-content-primary odd:bg-background-secondary">
            <div className="mt-1 flex size-4 items-center justify-start">
                <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <div className="flex flex-col">
                <div className="flex flex-row flex-wrap gap-2">
                    <Heading level={headingLevel} className="text-sm font-semibold">
                        {title}
                    </Heading>
                    {badge && badge}
                </div>
                {description && <p className="text-xs font-medium">{description}</p>}
            </div>
        </div>
    );
};

export default TableRow;
